import React from 'react';

function DirectoryHero({ spotlightName, totalCount = 0 }) {
  return null;
}

export default DirectoryHero;